'use client';

import { PropsWithChildren, ReactNode, useState } from 'react';
import colors from '#/lib/colors';
import { ThemeProvider } from 'bouqei';
import { IntlProvider } from 'react-intl';
import { ShellContext } from '#/context/ShellContext';
import { Box, ThemeProvider as MuiThemeProvider } from '@mui/material';
import { muiTheme } from '#/lib/theme';
import Main from './Main';

type Props = PropsWithChildren & {
  nav?: ReactNode;
  sidebar?: ReactNode;
};

export default function Shell({ children, nav, sidebar }: Props) {
  const [showSidebar, setShowSidebar] = useState(false);

  return (
    <ShellContext.Provider value={{ showSidebar, setShowSidebar }}>
      <MuiThemeProvider theme={muiTheme}>
        <ThemeProvider theme={colors}>
          <IntlProvider locale="en">
            <Main>
              {sidebar}
              <Box flex="1">
                {nav}
                {children}
              </Box>
            </Main>
            <div id="modal" />
          </IntlProvider>
        </ThemeProvider>
      </MuiThemeProvider>
    </ShellContext.Provider>
  );
}
